import { Search } from '@material-ui/icons';
import Link from 'next/link';

const LeadBar = () => {
  return (
    <LinkContainer link={'/explore'}>
      <div className="hover:cursor-pointer">
        <div className="flex drop-shadow min-w-full bg-[#EAE4F7] text-black rounded-lg p-2 w-12/12 lg:h-27 items-center mb-2">
          <div className="md:flex content-center whitespace-nowrap mt-2 mb-2">
            <Search fontSize="medium" className="text-[#A8A8A8]" aria-hidden="true" />
            <div className="ml-1 text-sm text-nowrap me">{'Find and book another top Huddle builder on'} </div>
            <div className="underline text-sm ml-1 font-bold whitespace-nowrap sm:ml-1">Explore.</div>
          </div>
        </div>
      </div>
    </LinkContainer>
  );
};

const LinkContainer = ({ children, link, newTab }: { children: React.ReactChild; link?: string; newTab?: boolean }) => {
  if (link)
    return (
      <Link href={link} passHref>
        <a target={newTab ? '_blank' : '_self'}>{children}</a>
      </Link>
    );
  return <div>{children}</div>;
};

export default LeadBar;
